/**
 * LastPlaybookWarningDialog Component
 *
 * Warning dialog shown when user tries to move the last playbook from a strategy.
 * Warns that the strategy will be left empty after the move.
 */

import React from 'react';

import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from '@enfomentis/ui';

export interface LastPlaybookWarningDialogProps {
  /** Whether the dialog is open */
  isOpen: boolean;
  /** Called when user clicks Cancel */
  onClose: () => void;
  /** Called when user confirms the move */
  onConfirm: () => void;
  /** Name of the strategy that will be left empty */
  strategyName: string;
}

export const LastPlaybookWarningDialog: React.FC<LastPlaybookWarningDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  strategyName,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <ModalContent>
        <ModalHeader>Move Last Playbook?</ModalHeader>
        <ModalBody>
          <p className="text-text-secondary">
            This is the only playbook in "{strategyName}". Moving it will leave the strategy empty.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button variant="flat" onPress={onClose}>
            Cancel
          </Button>
          <Button color="warning" onPress={onConfirm}>
            Move Anyway
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
